import { useContext } from 'react';
import { LivestreamSessionContext } from './LivestreamSessionContext';
import { VideoConferenceContext } from './VideoConferenceContext';

export const useLivestreamSessionContext = () => {
  const context = useContext(LivestreamSessionContext);
  if (!context) {
    throw new Error('useLivestreamSessionContext must be used within a LivestreamSessionProvider');
  }
  return context;
};

export const useVideoConferenceContext = () => {
  const context = useContext(VideoConferenceContext);
  if (!context) {
    throw new Error('useVideoConferenceContext must be used within a VideoConferenceProvider');
  }
  return context;
};
